<template>
  <Loading v-if="loading || loadingTimer"></Loading>
  <!-- <div v-else-if="closeDevtools" class="h-[100vh] w-[100vw] grid place-content-center font-medium text-3xl">close dev tools </div> -->
  <div v-else>
    <TheHeader />
    <router-view />
    <TheFooter />
    <div
      v-if="$route.name != 'Home'"
      class="
        fixed
        ltr:right-10
        rtl:left-10
        bottom-10
        h-16
        bg-primary
        rounded-full
        border
        w-10
         hidden lg:flex flex-col
        items-center
        justify-between
        py-1
      "
    >
      <DownIcon class="w-6 h-6 cursor-pointer" @click="scrollDown" />
      <DownIcon class="w-6 h-6 cursor-pointer rotate-180" @click="scrollUp" />
    </div>
  </div>
</template>

<script>
import TheHeader from "./components/Layout/TheHeader.vue";
import TheFooter from "./components/Layout/TheFooter.vue";
import Loading from "./views/Loading.vue";
import languages from "@/assets/languages.js";
import devtools from "devtools-detect/index.js";
import DownIcon from "./assets/icons/DownIcon.vue";
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

let language = null;
if (
  localStorage.getItem("lang") == null ||
  localStorage.getItem("lang") == undefined
) {
  localStorage.setItem("lang", "en");
  language = "en";
} else {
  language = localStorage.getItem("lang");
}

export default {
  provide: {
    content: languages[language],
  },
  data() {
    return {
      loadingTimer: true,
      closeDevtools: false,
    };
  },
  components: {
    TheHeader,
    TheFooter,
    Loading,
    DownIcon,
  },
  computed: {
    loading() {
      return this.$store.getters["isLoading"];
    },
  },
  watch: {
    loading() {
      if (this.loading) {
        const images = document.getElementsByTagName("img");

        for (let i = 0; i < images.length; i++) {
          images[i].addEventListener("contextmenu", (event) =>
            event.preventDefault()
          );
        }
      }
    },
    closeDevtools() {
      // check if is ios
      let iOSDevice = !!navigator.platform.match(/iPhone|iPod|iPad/);
      if (iOSDevice) {
        this.closeDevtools = false;
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.$store.dispatch("getAll", this.$route.name);
    }, 2);
    document.body.style.webkitTouchCallout = "none";
    // var isChrome =
    //   /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    setTimeout(() => {
      this.loadingTimer = false;
    }, 2300);
    if (language == "en") {
      document.body.setAttribute("dir", "ltr");
    } else {
      document.body.setAttribute("dir", "rtl");
      document.body.classList.add("rtl");
    }

    document.body.addEventListener("contextmenu", (event) =>
      event.preventDefault()
    );
    document.onkeydown = function (e) {
      if (event.keyCode == 123) {
        return false;
      }
      if (e.ctrlKey && e.keyCode == "S".charCodeAt(0)) {
        return false;
      }
      if (e.ctrlKey && e.keyCode == "P".charCodeAt(0)) {
        return false;
      }
      if (e.ctrlKey && e.shiftKey && e.keyCode == "I".charCodeAt(0)) {
        return false;
      }
      if (e.ctrlKey && e.shiftKey && e.keyCode == "C".charCodeAt(0)) {
        return false;
      }
      if (e.ctrlKey && e.shiftKey && e.keyCode == "J".charCodeAt(0)) {
        return false;
      }
      if (e.ctrlKey && e.keyCode == "U".charCodeAt(0)) {
        return false;
      }
      if (e.keyCode == "PrintScreen".charCodeAt(0)) {
        navigator.clipboard.writeText("");
        alert("Screenshots disabled!");
      }
    };
    // Check if it's open
    if (devtools.isOpen) {
      this.closeDevtools = true;
    } else if (devtools.orientation != undefined) {
      this.closeDevtools = true;
    } else {
      this.closeDevtools = false;
    }

    window.addEventListener("devtoolschange", (event) => {
      if (event.detail.isOpen) {
        this.closeDevtools = true;
      } else if (event.detail.orientation != undefined) {
        this.closeDevtools = true;
      } else {
        this.closeDevtools = false;
      }
    });
  },
  methods: {
    scrollUp() {
      gsap.to(window, {
        duration: 1.5,
        scrollTo: { y: window.scrollY + 400, x: 0 },
      });
    },
    scrollDown() {
      gsap.to(window, {
        duration: 1.5,
        scrollTo: { y: window.scrollY - 400, x: 0 },
      });
    },
  },
};
</script>
